// extracted by mini-css-extract-plugin
export default {"root":"Html_root__ZMQnC","boldLinks":"Html_boldLinks__0WJSy"};